import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";

import api from "../../../services/api";
import Menu from "../../../components/Menu";

const initialState = {
    estoque_id: "",
    descricao: "",
    barra: "",
    codigo: "",
}

const stockInitialState = {
    produto_id: "",
    quantidade: 0,
    minimo: 0
}

export default function EstoqueProdutos() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});
    const [formStock, setFormStock] = useState(stockInitialState);
    const [produtos, setProdutos] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);
    const [types, setTypes] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isItemVisible, setIsItemVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(rowData[props.field]);
    }

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("estoque/produtos").then((response) => {
            setIsLoading(false);
            setData(response.data);
        }).catch((error) => {
            setIsLoading(false);
        });
    }, []);

    const fetchProdutos = useCallback(() => {
        api.get("produtos").then((response) => {
            setProdutos(response.data);
        }).catch((error) => {

        });
    }, []);

    const handleSubmitStock = _ => {
        setIsLoading(true);
        api.post("estoque/produtos", formStock).then((response) => {
            fetchData();
            setIsLoading(false);
            showSuccess(response);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }

    const onHide = _ => setIsVisible(false);
    const onShow = _ => setIsVisible(true);

    const onHideItem = _ => setIsItemVisible(false);
    const onShowItem = rowData => {
        setIsItemVisible(true);
        setForm({ ...rowData });
    }

    const renderFooter = _ => {
        return (
            <div>
                <Button className="p-button-secondary" label="Cancelar" onClick={onHide} />
                <Button className="p-button-success" label="Salvar" onClick={handleSubmitStock} />
            </div>
        )
    }

    const renderFooterItem = _ => {
        return (
            <div>
                <Button className="p-button-secondary" label="Cancelar" onClick={onHideItem} />
                <Button className="p-button-success" label="Salvar" />
            </div>
        )
    }

    const renderStockItems = data => {
        return (
            <div>
                <h3 className="p-m-2">Itens do Estoque: </h3>
                <DataTable
                    emptyMessage="Nenhum item encontrado."
                    expandedRows={expandedRows}
                    responsiveLayout="scroll"
                    size="small"
                    value={[]}
                >
                    <Column header="ID" field="id" />
                    <Column header="Barra" field="barra" />
                    <Column header="Código" field="codigo" />
                    <Column header="Status" field="status" />
                    <Column header="Ações" />
                </DataTable>
            </div>
        )
    }

    useEffect(() => {
        fetchData();
        fetchProdutos();
    }, [fetchData, fetchProdutos]);

    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Estoque de Produtos"
            >
                <div className="p-d-flex p-flex-row p-jc-between p-m-2">
                    <MultiSelect
                        onChange={e => setTypes(e.value)}
                        placeholder="Selecione o tipo de produto"
                        value={types}
                    />
                    <Button className="p-button-success" icon="pi pi-plus" onClick={onShow} />
                </div>

                <Dialog
                    footer={renderFooter}
                    header="Criar Estoque"
                    onHide={onHide}
                    position="top"
                    style={{ width: "30vw" }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="produto">Produto: </label>
                            <Dropdown
                                filter
                                onChange={e => setFormStock({ ...formStock, produto_id: e.value })}
                                options={produtos}
                                optionLabel="descricao2"
                                optionValue="id"
                                placeholder="Escolha um produto para iniciar o estoque"
                                value={formStock.produto_id}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="quantidade">Quantidade: </label>
                            <InputText
                                onChange={e => setFormStock({ ...formStock, quantidade: e.target.value })}
                                placeholder="Exemplo: 4"
                                value={formStock.quantidade}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="minimo">Estoque Mínimo: </label>
                            <InputText
                                onChange={e => setFormStock({ ...formStock, minimo: e.target.value })}
                                placeholder="Exemplo: 4"
                                value={formStock.minimo}
                            />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    footer={renderFooterItem}
                    header="Criar Item"
                    onHide={onHideItem}
                    position="center"
                    style={{ minWidth: "30vw" }}
                    visible={isItemVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="produto">Produto: </label>
                            <InputText
                                readOnly
                                value={form.descricao}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="codigo_produto">Código do Produto: </label>
                            <InputText
                                onChange={e => setForm({ ...form, codigo: e.target.value })}
                                value={form.codigo}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="barra">Código de Barras: </label>
                            <InputText
                                onChange={e => setForm({ ...form, barra: e.target.value })}
                                value={form.barra}
                            />
                        </div>
                    </div>
                </Dialog>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    expandedRows={expandedRows}
                    onRowToggle={e => setExpandedRows(e.data)}
                    rowExpansionTemplate={renderStockItems}
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column expander style={{ width: "3vw" }} />
                    <Column header="Produto" field="descricao" sortable />
                    <Column header="Quantidade" field="quantidade" body={(rowData) => (
                        <Tag style={{ fontSize: 16 }} severity={parseFloat(rowData.quantidade) >= parseFloat(rowData.minimo) ? "success" : "danger"}>
                            {Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 }).format(rowData.quantidade)}
                        </Tag>
                    )} sortable />
                    <Column header="Mínimo" field="minimo" body={(rowData) => (
                        <Tag style={{ fontSize: 16 }} >{rowData.minimo}</Tag>
                    )} sortable />
                    <Column header="Valor" field="valor_unico" body={formatNumber} sortable />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button className="p-button-help p-mr-2" icon="pi pi-cog" />
                            <Button className="p-button-success p-mr-2" icon="pi pi-plus" onClick={() => onShowItem(rowData)} />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}